import React from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import CommonActionItem from './CommonActionItem';

/**
 * @typedef CommonActionsGroupProps
 * @prop {import('./models/RecordAction').default[]} actions
 */

/**
 * @type {React.FC<CommonActionsGroupProps>}
 */
const CommonActionsGroup = ({ actions }) => {
  return (
    <aha-menu-group>
      {actions.map(action => (
        <CommonActionItem action={action} key={action.constructor.name} />
      ))}
    </aha-menu-group>
  );
};

export default view(CommonActionsGroup);
